import { useAppContext, useAppDispatch } from '../../../providers';
import { useSelectedResource, useResources } from '../../../hooks';
import { useEffect } from 'react';

import { Select } from '@pella/sash-framework';
import { Back, Tabs } from '../../molecules';
import { StatusContent } from '../../organisms';

import * as classes from './Worklist.module.css';
import { useSearchParams } from 'react-router-dom';
import { ACTIVE_TAB } from '../../../providers/AppProvider/types';

const TABS = ['Worklist', 'Queues'];

/**
 * Worklist page
 */
export const Worklist = () => {
  const { activeTab } = useAppContext();
  const dispatch = useAppDispatch();

  const { selectedResource, setSelectedResource } = useSelectedResource();
  const { data: resources } = useResources(false, true);
  const [searchParams] = useSearchParams();

  // check for query param to set active tab
  useEffect(() => {
    const view = searchParams.get('view');
    dispatch({ type: ACTIVE_TAB, payload: view && TABS.includes(view) ? view : TABS[0] });
  }, [searchParams, dispatch]);

  /**
   * Handles changes to the selected resource.
   * @param {React.ChangeEvent<HTMLSelectElement>} event - The change event object.
   * @returns {void}
   */
  const handleResourceChange = ({ target: { value } }) => {
    if (value) setSelectedResource(value);
  };

  return (
    <div className={classes.container}>
      <Back />
      <div className={classes.select}>
        <Select
          id='resource-selection'
          labelText='Select Resource'
          onChange={handleResourceChange}
          value={selectedResource}
        >
          <option value=''>--- Select an Option ---</option>
          {resources?.map((res) => (
            <option key={res.id} value={res.id}>
              {res.description}
            </option>
          ))}
        </Select>
      </div>
      <div className={classes.content}>
        {selectedResource && (
          <>
            <Tabs tabs={TABS} />
            {activeTab && <StatusContent />}
          </>
        )}
      </div>
    </div>
  );
};
